import getStylePropertyValue from "./getStylePropertyValue";

// Adapted from https://stackoverflow.com/a/10787807/685925
//
export default function getElementOuterHeight(element) {
  const elementHeight = getStylePropertyValue(element, "height");
  const elementMargin = (
    getStylePropertyValue(element, "margin-top") +
    getStylePropertyValue(element, "margin-bottom")
  );

  return elementHeight + elementMargin;
}
